export function PlanPrice({
  price,
  period,
  compareAtPrice,
  promotionText,
}: {
  price: string;
  period: string;
  compareAtPrice?: string;
  promotionText?: string;
}) {
  return (
    <div className="mb-1">
      {compareAtPrice ? (
        <p className="text-sm text-slate-500 line-through">{compareAtPrice}</p>
      ) : null}
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
        <span className="text-2xl font-bold text-slate-100">{price}</span>
        {period ? (
          <span className="text-slate-400 text-sm">{period}</span>
        ) : null}
        {promotionText ? (
          <span className="inline-block rounded-full bg-maroon px-2 py-0.5 text-xs font-semibold text-white">
            {promotionText}
          </span>
        ) : null}
      </div>
    </div>
  );
}
